import { createSvgIcon } from '@ori-ui/mui-bundle/material/utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 13.5a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5m-.5 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.282 4.648a1.5 1.5 0 0 0-2.564 0L3.995 15.721A1.5 1.5 0 0 0 5.277 18h13.446a1.5 1.5 0 0 0 1.282-2.279zm-1.71.52a.5.5 0 0 1 .855 0L19.15 16.24a.5.5 0 0 1-.427.76H5.277a.5.5 0 0 1-.428-.76z"
  })]
}), 'Warning');
//# sourceMappingURL=index.js.map